import { SurveySection } from '../../entities/survey_engine/SurveySection';

export function getSurveyQuestions(sections: SurveySection[]) {
  return sections.flatMap((section) => section.questions);
}
